export let Status = /*#__PURE__*/function (Status) {
  Status["UNKNOWN_STATUS"] = "UNKNOWN_STATUS";
  Status["PENDING"] = "PENDING";
  Status["IN_PROGRESS"] = "IN_PROGRESS";
  Status["WAITING"] = "WAITING";
  Status["ACTION_NEEDED"] = "ACTION_NEEDED";
  Status["IN_REVIEW"] = "IN_REVIEW";
  Status["PAUSED"] = "PAUSED";
  Status["COMPLETED"] = "COMPLETED";
  Status["CANCELLED"] = "CANCELLED";
  Status["FAILED"] = "FAILED";
  return Status;
}({});
export let Rating = /*#__PURE__*/function (Rating) {
  Rating["UNKNOWN_RATING"] = "UNKNOWN_RATING";
  Rating["UP"] = "UP";
  Rating["DOWN"] = "DOWN";
  return Rating;
}({});
export let SortOrder = /*#__PURE__*/function (SortOrder) {
  SortOrder["ASC"] = "ASC";
  SortOrder["DESC"] = "DESC";
  return SortOrder;
}({});
//# sourceMappingURL=types.js.map